import * as React from 'react';
import { connect } from 'react-redux';
import AccountActions from './account_actions';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import { opt } from 'arm-common';

import { Utils, domainVal, NumberFormatter, DateFormatter, i18n } from 'arm-common';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.loginOnClick = this.loginOnClick.bind(this);
        this.testOnClick = this.testOnClick.bind(this);
        this.resetPasswordOnClick = this.resetPasswordOnClick.bind(this);

        this.componentName = "[Login.jsx] ";

        let username = null;
        let password = null;

        console.log(this.componentName + "AppConstants.DEBUG_VIEW: " + AppConstants.DEBUG_VIEW);

        if (AppConstants.DEBUG_VIEW === true) {
            //PER IL DEBUG
            username = 'armundia1';
            password = '4rmuPass2020!1';
            // password = 'Nondarepiu8102!';

            // username = 'd.terova';
            //  password = 'damjan';
        }

        this.state = {
            validation: new Map(),
            user: {},
            //loggedIn: LoginStore.getLoggedIn(),
            messageError: null,
            //PER IL DEBUG
            username: username,
            password: password
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        this.props.getVersione();
        let otssoToken = null;
        this.props.sso(otssoToken).then(
            resolve => {
                console.log("[Login.jsx] SSO -> resolve", resolve);
                if (resolve.userId !== null && resolve.userId !== undefined) {
                    this.props.login(resolve.userId, null).then(
                        resolve => {
                            console.log(this.componentName + '\login: resolve');
                            this.props.history.push({ pathname: '/home' });
                        },
                        reject => {
                            console.log(this.componentName + '\login: reject');
                        }
                    );
                }
            },
            reject => {
                console.log("[Login.jsx] SSO -> reject");
            });
    }

    validateForm() {
        let validation = new Map();
        let required = ['username', 'password'];
        for (let i = 0; i < required.length; i++) {
            if (this.state[required[i]] === undefined || this.state[required[i]] === '' || this.state[required[i]] === null) {
                validation.set(required[i], 'valore obbligatorio');
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    loginOnClick(e) {
        e.preventDefault();
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return;
        }
        console.log("\tloginOnClick - start");
        this.props.login(this.state.username, this.state.password).then(
            resolve => {
                if (this.props.utente.datePasswordModified) {
                    if (opt("APP", "FL_VIEW_MSG_SCADENZA_PASSWORD", "false") === "true") {
                        this.checkGiorniPrimaChePasswordScade();
                    }
                    this.props.history.push({ pathname: '/home', state: { showCollapse: true } });
                } else {
                    this.props.history.push({ pathname: '/changePassword' });
                }
            },
            reject => {
                console.log("Login -> reject");
            }
        );
        //this.props.test(this.state.username, this.state.password);
        console.log("\tloginOnClick - end");
    }



    inputChangeHandler(e, index) {
        // console.log(this.componentName + ' handleChange id: ' + id + ' value: ' + value);
        if (e !== null && e !== undefined) {
            let obj = {};
            let value = e.target.value;
            let id = e.target.id;
            obj[id] = value;
            this.setState(obj)
        }
    }

    componentWillUnmount() {
        console.log(this.componentName + 'componentWillUnmount');
    }

    componentWillMount() {
        console.log(this.componentName + 'componentWillMount');
    }

    testOnClick() {
        this.props.history.push({ pathname: '/test' });
    }

    resetPasswordOnClick() {
        console.log(this.componentName + 'resetPasswordOnClick');

        this.props.history.push({ pathname: '/resetPassword' });
    }

    checkGiorniPrimaChePasswordScade() {
        let datePassword = new Date(Number(this.props.utente.datePasswordModified));
        let today = new Date();
        // To calculate the time difference of two dates 
        let diff_In_time = today.getTime() - datePassword.getTime();
        // To calculate the no. of days between two dates 
        let diff_In_days = diff_In_time / (1000 * 3600 * 24);
        let giorniPrimaChePassScade = 90 - diff_In_days;
        if (giorniPrimaChePassScade <= 30 && giorniPrimaChePassScade > 10) {
            this.props.addNotify('WARNING', i18n('ARM.CORE.PRODUCT.PASSWORD.SCADRA', 'La password scade tra meno di 30 giorni !'));
        } else if (giorniPrimaChePassScade <= 10) {
            this.props.addNotify('DANGER',  i18n('ARM.CORE.PRODUCT.PASSWORD.SCADRA.10_GIORNI','La password scade tra meno di 10 giorni !'));
        }
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="container justify-content-center mt-3" style={{ maxWidth: '500px' }}>
                <agui.aCardV4>
                    <agui.aCardV4Header >
                        <h3 className="panel-title">Login</h3>
                    </agui.aCardV4Header>
                    <form>
                        <agui.aCardV4Body>

                            <agui.ATextInputV4 id="username"
                                type="text"
                                value={this.state.username}
                                placeholder="inserire username"
                                autocomplete="off"
                                label="Username*"
                                validation={this.state.validation}
                                onChange={this.inputChangeHandler}
                                disabled={this.props.isSSO} />

                            <agui.ATextInputV4 id="password" type="password"
                                value={this.state.password ? this.state.password : ''}
                                autocomplete="off"
                                validation={this.state.validation} placeholder="inserire password"
                                label="Password*"
                                onChange={this.inputChangeHandler}
                                disabled={this.props.isSSO} />

                        </agui.aCardV4Body>
                    </form>
                    <div className="">
                        {AppConstants.AREA_TEST_IS_ENABLED ? <button type="button" className="btn btn-primary" onClick={this.testOnClick} >Test</button> : null}
                        <button type="submit" className="btn btn-primary float-right mr-3" onClick={this.loginOnClick} ><i className="fa fa-user fa-fw" />Login</button>
                    </div>

                    <div className="row col-12 ">
                        <p className="mt-3 ml-4">{i18n('QUOTRV2.LOGIN.SE_TI_SEI_DIMENTICATO_LA', 'Se ti sei dimenticato la ')}<b>password</b> &nbsp; <a onClick={this.resetPasswordOnClick}>{i18n('ARM_CORE_QUEST.SHARED.RECOVER_HERE', 'recuperala qui')}</a></p>
                    </div>

                    <div className="mt-2" style={{ textAlign: "center" }}>
                        <div className="row col-12 ">
                            <p className="col-12 text-center font-weight-light">
                                <small title={"ARM-CORE-PRODUCT : " + this.props.version && this.props.version.descrizione}>{i18n('ARM_CORE_PRODUCT.LOGIN.POWERED', 'ARM-CORE-PRODUCT powered BY Armundia GROUP') + "  "} v. {this.props.version && this.props.version.descrizione}</small></p>
                        </div>
                    </div>

                </agui.aCardV4>

            </div>
        );
    }
};


function mapDispatchToProps(dispatch) {
    return {
        login(username, password) {
            console.log('Dispatch ... login')
            return dispatch(AccountActions.login(username, password)).then(
                resolve => {
                    if (resolve[0] && !resolve[0].datePasswordModified && resolve[0].erroreCode) {
                        dispatch(AppActions.addNotify('WARNING', 'Password scaduta!'));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM.CORE.PRODUCT.LABEL.BENVENUTO',  'Benvenuto ' ) +  username));
                    }
                    return resolve;
                },
                reject => {
                    console.log('[Login] getJSON: reject:');
                    return reject;
                }
            );
        },
        aggiornaPortafoglio(idRischio) {
            return dispatch(PolizzeActions.aggiornaPortafoglio(idRischio));
        },
        getVersione() {
            return dispatch(AccountActions.getVersione());
        },
        addNotify(tipo, messaggio) {
            return dispatch(AppActions.addNotify(tipo, messaggio));
        },
        sso: (otssoToken) => dispatch(AccountActions.sso(otssoToken))
    }
};

function mapStateToProps(state) {
    return {
        utente: state.account.utente,
        version: state.account.version,
        isSSO: state.account.isSSO,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);